// extracted by mini-css-extract-plugin
module.exports = {"root":"title_root__LfNkb","subtitle":"title_subtitle__6FQ6u"};